import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const root = css`
  display: table;
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
`;

export const tableCell = (theme: Theme) => css`
  padding: ${theme.spacing[4]} 0;
  text-align: left;
  vertical-align: middle;
`;

export const tableRow = css`
  border: none;
`;

export const striped = (theme: Theme) => css`
  background: ${theme.palette.background.accent};
`;

export const fontWeightBold = css`
  font-weight: 500;
`;

export const clickable = (theme: Theme) => css`
  cursor: pointer;

  &:hover {
    background: ${theme.palette.tertiary.lowContrast};
  }
`;
